/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useEffect, useState } from 'react';
import styles from '../styles/Home.module.css';
import FROutputCallbackBasedView from '../components/forms/common/FROutputCallBackBasedView';
import { FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import { trees } from '../config';
import { useLocation, useNavigate,} from 'react-router-dom';
import PersonnelInfo from '../components/Profile/personnelInfo';
import AddCompany from '../components/Profile/addCompany';
import MyEngineModelStatus from '../components/Profile/MyEngineModelStatus';
// import { isEmpty } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import ChangePassword from '../components/Profile/changePassword';
import ChangeMFA from '../components/Profile/changeMFA';
import stylesmodal from '../styles/MyProfileStyles.module.css';
import SuccessErrorModal , { MessageType } from '../components/modals/SuccessErrorModal';
import {setIsValueChanged} from '../redux/watchNavigationSlice';
import { store } from '../redux/store';
// import { setIsAlertOpen } from '../redux/userRolesSlice';

const tree = trees.profileUpdate

const companyTree = trees.addCompany;

const MyProfile = () => {

  const [isSuccessOpen,setIsSuccessOpen]  = useState(false);
  const [successMesssage,setSuccessMesssage]  = useState("");

  const [value, setValue] = useState('1');

  const navigate = useNavigate();


  const [widthscreen,setwidth] = useState(window.innerWidth);
  const breakpoint = 700;

  useEffect(()=>{
    const handleWindowSizeChange = () => {
      setwidth(window.innerWidth);
    };
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  },[])

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log(store.getState()?.watchNavigation.isValueChanged)
    if(!(store.getState()?.watchNavigation.isValueChanged)){
      navigate('/myprofile?tab=' + newValue);
      setValue(newValue)
      store.dispatch(setIsValueChanged(false));
    } else {
      if(window.confirm("your changes will be lost")){
        navigate('/myprofile?tab=' + newValue);
        setValue(newValue)
        store.dispatch(setIsValueChanged(false));
      }
    }
    setIsSuccessOpen(false)
    setSuccessMesssage("");
    
  };

  const location = useLocation();

  useEffect(() => {
    const tabParam = new URLSearchParams(location.search).get('tab') || ''
    if (isEmpty(tabParam)) {
      navigate('/myprofile?tab=' + 'personnelInfo');
    }
    setValue(tabParam)
  }, [location]);



  useEffect(() => {
    store.dispatch(setIsValueChanged(false));
  }, [isSuccessOpen]);


  const handleClose = () =>{
    setIsSuccessOpen(false);
  }

  if ( widthscreen > breakpoint){
  return (
    <>
      {/* <div style={{ width :'1008px !important',height :' 32px !important'}}> */}
      <div className="bannerAuth"  >
        <div className="leftbanner" >{" US and Non-US Persons "}</div >
        <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
        <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
      <div className={stylesmodal.msgcontainer}>
        <div className={stylesmodal.message}>
          <SuccessErrorModal
            type={MessageType.success}
            open={isSuccessOpen}
            handleClose={handleClose}
            message={successMesssage}
          />
        </div>
      </div>
      <div className={styles.protectPage_title_container}>
        <div className={styles.protectPage_title}>My Account</div>
      </div>
  <main className={styles.protectedMain}> 
    <TabContext value={value}>
    <Box component="div" className={styles.boxStyles} >
      <TabList onChange={handleChange} aria-label="myProfile-Tabs" variant="scrollable" scrollButtons="auto">
        <Tab label="Personal" value="personnelInfo" className={styles.tabHeaderTextStyles} />
        <Tab label="Company" value="company"  className={styles.tabHeaderTextStyles}/>
        <Tab label="Password" value="password"  className={styles.tabHeaderTextStyles}/>
        {/* <Tab label="My Engine Models" value="myEngineModels"  className={styles.tabHeaderTextStyles}/> */}
        {/* <Tab label="MFA" value="mfa" /> */}
      </TabList>
    </Box>
    <TabPanel value="personnelInfo"><PersonnelInfo  setIsSuccessOpen = {setIsSuccessOpen} setSuccessMesssage = {setSuccessMesssage}/></TabPanel>
    <TabPanel value="company"><AddCompany setIsSuccessOpen = {setIsSuccessOpen} setSuccessMesssage = {setSuccessMesssage}/></TabPanel>
    <TabPanel value="password"><ChangePassword setIsSuccessOpen = {setIsSuccessOpen} setSuccessMesssage = {setSuccessMesssage}/></TabPanel>
    {/* <TabPanel value="myEngineModels"><MyEngineModelStatus/></TabPanel> */}
    {/* <TabPanel value="mfa"><ChangeMFA/></TabPanel> */}
  </TabContext>
  </main>
  </>
  )} else {
    return (
      <>
        {/* <div style={{ width :'1008px !important',height :' 32px !important'}}> */}
        <div className="bannerAuth"  >
        <div className="leftbanner" >{" US and Non-US Persons "}</div >
        <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
        <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
        <div className={stylesmodal.msgcontainer}>
          <div className={stylesmodal.message}>
            <SuccessErrorModal
              type={MessageType.success}
              open={isSuccessOpen}
              handleClose={handleClose}
              message={successMesssage}
            />
          </div>
        </div>
        <div className={styles.protectPage_title_container}>
          <div className={styles.protectPage_title}>My Account</div>
        </div>
    <main className={styles.protectedMain}> 
      <TabContext value={value}>
      <Box component="div" className={styles.boxStyles}>
        <TabList onChange={handleChange} aria-label="myProfile-Tabs" variant="scrollable"  scrollButtons orientation="vertical" visibleScrollbar>
          <Tab label="Personal" value="personnelInfo" className={styles.tabHeaderTextStyles} />
          <Tab label="Company" value="company"  className={styles.tabHeaderTextStyles}/>
          <Tab label="Password" value="password"  className={styles.tabHeaderTextStyles}/>
          {/* <Tab label="My Engine Models" value="myEngineModels"  className={styles.tabHeaderTextStyles}/> */}
          {/* <Tab label="MFA" value="mfa" /> */}
        </TabList>
      </Box>
      <TabPanel value="personnelInfo"><PersonnelInfo  setIsSuccessOpen = {setIsSuccessOpen} setSuccessMesssage = {setSuccessMesssage}/></TabPanel>
      <TabPanel value="company"><AddCompany setIsSuccessOpen = {setIsSuccessOpen} setSuccessMesssage = {setSuccessMesssage}/></TabPanel>
      <TabPanel value="password"><ChangePassword setIsSuccessOpen = {setIsSuccessOpen} setSuccessMesssage = {setSuccessMesssage}/></TabPanel>
      {/* <TabPanel value="myEngineModels"><MyEngineModelStatus/></TabPanel> */}
      {/* <TabPanel value="mfa"><ChangeMFA/></TabPanel> */}
    </TabContext>
    </main>
    </>
    );
  
  }
};

export default MyProfile;
